export type IExemptionPropertyDamagedFormFirstSection = {
    TaxYear?: string;
}

export const ExemptionPropertyDamagedFormFirstSectionInterface = (): IExemptionPropertyDamagedFormFirstSection => ({
    TaxYear: undefined
})